<script lang="ts">
  import { onMount } from 'svelte';
  import type { SwiperOptions } from 'swiper/types';
  import { isMobileWidth } from '../../../common/util';
  import ExtraSwiper from '../../common/components/ExtraSwiper.svelte';
  import Text from '../../common/components/Text.svelte';
  import { getRelatedBlogs } from '../services/blog-data-services';
  import BlogCard from './BlogCard.svelte';
  import BlogCardSkeletonLoader from './BlogCardSkeletonLoader.svelte';

  export let relatedBlog: any;
  let relatedBlogPosts: Array<any> = [];
  let relatedPostsLoaded: boolean = false;

  const isResponsive = isMobileWidth();
  const spaceBetween = isResponsive ? 15 : 60;
  const slidesPerView = 'auto';
  const swiperOptions = getSwiperOptions(slidesPerView, spaceBetween);

  onMount(() => {
    getPosts();
  });
  async function getPosts() {
    try {
      // Fetch related blog posts
      const response = await getRelatedBlogs(relatedBlog);

      // Check if response exists and has data
      if (Array.isArray(response) && response.length > 0) {
        relatedBlogPosts = response.filter(Boolean); // Boolean filters out null, undefined, and false
        relatedPostsLoaded = true;
      }
    } catch (error) {
      console.error('Error fetching related blogs:', error);
      relatedPostsLoaded = false;
    }
  }

  function getSwiperOptions(slidesPerView, spaceBetween): SwiperOptions {
    return {
      slidesPerView,
      spaceBetween,
    };
  }
</script>

{#if relatedBlogPosts && relatedBlogPosts.length}
  {#if !relatedPostsLoaded}
    <BlogCardSkeletonLoader />
  {:else}
    <section class="related-blog-post-container">
      <div class="related-blog-post">
        <h5 class="related-blog-post-heading">
          <Text key="extra.ampliance.blog.relatedArticle" />
        </h5>
        <ExtraSwiper slidesData={relatedBlogPosts} slideTemplate={BlogCard} {swiperOptions} />
      </div>
    </section>
  {/if}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .related-blog-post-container {
    background: $neutral-light-04;
    border-top: 1px solid $primary-black;
    border-bottom: 1px solid $primary-black;
    margin-top: 10px;
    padding: 90px 0;
    @include desktop-max-width {
      border: none;
      padding: 0 16px;
      background: $primary-white;
    }
    .related-blog-post {
      max-width: 1440px;
      margin-inline: auto;
      padding: 0 48px;
      @include desktop-max-width {
        padding: 0;
      }
      .related-blog-post-heading {
        font-size: 34px;
        line-height: 40px;
        color: $neutral-dark-01;
        font-weight: 700;
        text-transform: capitalize;
        margin-bottom: 40px;
        @include desktop-max-width {
          font-size: 18px;
          line-height: 20px;
          margin-bottom: 15px;
        }
      }
    }
    :global {
      .smui-card__content {
        background: $primary-white !important;
      }
      .swiper-slide {
        width: fit-content;
        display: inline-block;
        position: relative;
      }
    }
  }
</style>
